import { defineComponent, ref, watch } from "vue";
import BankDialog from "src/components/BankDialog.vue";
import BranchDialog from "src/components/BranchDialog.vue";
export default defineComponent({
    name: "BankSelectField",
    components: {
        BankDialog,
        BranchDialog
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false
        }
    },
    emits: ["update:modelValue", "select"],
    setup(props, { emit }) {
        const isBankDialog = ref(false);
        const selectedBank = ref(null);
        const isBranchDialog = ref(false);
        const openBankDialog = () => {
            selectedBank.value = null;
            isBankDialog.value = true;
        };
        const closeBankDialogs = () => {
            isBankDialog.value = false;
            isBranchDialog.value = false;
            selectedBank.value = null;
        };
        const handleBankSelect = (bank) => {
            selectedBank.value = bank;
            isBranchDialog.value = true;
        };
        const bankDialogReturn = () => {
            isBranchDialog.value = false;
        };
        const handleBranchSelect = ({ bank, branch }) => {
            emit("select", { bank, branch });
            closeBankDialogs();
        };
        watch(() => props.modelValue, value => {
            if (value) {
                openBankDialog();
            }
            else {
                closeBankDialogs();
            }
        }, { immediate: true });
        watch(isBankDialog, value => {
            emit("update:modelValue", value);
        });
        return {
            isBankDialog,
            selectedBank,
            isBranchDialog,
            openBankDialog,
            closeBankDialogs,
            handleBankSelect,
            bankDialogReturn,
            handleBranchSelect
        };
    }
});
